export default {
    state: {
        actionsData: [],
    },
    getters: {
        getActionsData(state) {
            return state.actionsData;
        },
    },

    mutations: {
        setActionsData(state, data) {
        state.actionsData = data;
        },
    },

    actions: {
        changeActionsData(context, data) {
            context.commit("setActionsData", data);
        },
    }
}